import styles from "../styles/GetAppLanding.module.scss";
import RemittanceCard from "./RemittanceCard";
import TOILogo from "../assets/toi_initiative.png";

const Hero = ({ rateModel, onUsdAmountChange, onRecipientAmountChange }) => {
  return (
    <section className={styles.hero} id="send-to-india">
      <div className={styles.heroInner}>
        <div className={styles.heroCopy}>
          <h1>
            Send Money to India
            <br />
            with the <span>best exchange rates</span>
          </h1>
          <p>
            Rates that beat the banks, no hidden fees, and cashback on every
            transfer. Built for Indians living in the US.
          </p>
          {/*<div className={styles.trustCard}>
            <span>A trusted initiative by:</span>
            <img src={TOILogo} alt="initiate" />
          </div>*/}
        </div>
        <RemittanceCard
          rateModel={rateModel}
          onUsdAmountChange={onUsdAmountChange}
          onRecipientAmountChange={onRecipientAmountChange}
        />
      </div>
    </section>
  );
};

export default Hero;
